export default (context) => {
	context.$axios.onRequest(async (config) => {
		const token = await $nuxt.$auth0.getTokenSilently();
		config.headers.Authorization = token ? `Bearer ${token}` : "";

		return config;
	});
};
